import customAxios from "./axiosConfig";

const getFormData = object => Object.keys(object).reduce((formData, key) => {
    if(Array.isArray(object[key])){
        if (key === "object_id") {
            if (!object[key])
                delete object[key];
        }
        formData.append(key, JSON.stringify(object[key]));
    }else{
        if (!object[key]) {
            delete object[key];
        } else if (key === "file") {
            formData.append(key, object[key], object[key].name);
        } else {
            formData.append(key, object[key]);
        }
    }
    return formData;
}, new FormData());

const DocumentService = {
    list: function(params) {
        var api_url = window.Urls['document-list']();
        return customAxios.get(api_url, {params: params});
    },
    listNextPage(next_url) {
        return customAxios.get(next_url);
    },
    retrieve(pk) {
        var api_url = window.Urls['document-detail'](pk);
        return customAxios.get(api_url);
    },
    create(data) {
        var api_url = window.Urls['document-list']();
        var headers = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        
        return customAxios.post(api_url, getFormData(data), headers);
    },
    update(pk, data) {
        var api_url = window.Urls['document-detail'](pk);
        var headers = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        
        return customAxios.put(api_url, getFormData(data), headers);
    },
    delete: function(pk) {
        var api_url = window.Urls['document-detail'](pk);
        return customAxios.delete(api_url);
    },
    years: function (params) {
        var api_url = window.Urls['document_years']();
        return customAxios.get(api_url, {params: params});
    },
    getTotals(params) {
        var api_url = window.Urls['document_totals']();
        return customAxios.get(api_url, {params: params});
    },
    download(pk) {
        let url = window.Urls['documents:download'](pk);
        window.location.href = url;
    },
    getFile(pk) {
        let url = window.Urls['documents:download'](pk);
        return fetch(url);
    },
    send(data) {
        let api_url = window.Urls['document_send']();
        return customAxios.post(api_url, data);
    },
    getFileSize(documentSizes) { // in megabytes
        let selectedSize = 0;
        let filesizeBase = 1000;

        if (documentSizes > 0) {
            selectedSize = documentSizes / Math.pow(filesizeBase, 2);
            selectedSize = Math.round(10 * selectedSize) / 10;
        }
        
        return selectedSize;
    },
    getFileSizeText(documentSizes) {
        let selectedSize = 0;
        let selectedUnit = "Bytes";
        let filesizeBase = 1000;

        if (documentSizes > 0) {
            let units = ['TB', 'GB', 'MB', 'KB', 'Bytes'];

            for (let i = 0; i < units.length; i++) {
                let unit = units[i];
                let cutoff = Math.pow(filesizeBase, 4 - i) / 10;

                if (documentSizes >= cutoff) {
                    selectedSize = documentSizes / Math.pow(filesizeBase, 4 - i);
                    selectedUnit = unit;
                    break;
                }
            }

            selectedSize = Math.round(10 * selectedSize) / 10;
        }
        
        return `${selectedSize} ${selectedUnit}`;
    },
    getContentType (data) {
        const api_url = window.Urls['document-list']() + 'get_content_type/'
        return customAxios.post(api_url, data)
    }
}

export default DocumentService;